import { sendRequest } from 'utils/utils'
import Infra from 'mobx/Infra'

const getNutrientsInformation = async (nutrientId: string) => {
	const res = await sendRequest(false, `${Infra.appParams.wruec}/v1/tenants/${Infra.appParams.c}/menu/nutrients/${nutrientId}`, 'get')
	return res?.data
}

export default { getNutrientsInformation }
